const LoansList = () => import('../screens/Loans/List/LoansList.vue');

export default [
  {
    children: [
      {
        component: LoansList,
        meta: { pageTitle: 'Loans' },
        name: 'loans',
        path: '',
      },
    ],
    meta: {
      activeSidebarItemId: 'loans',
      authority: 'loans:view',
    },
    path: '/loans',
  },
];
